export const MARKETING_EMAIL_PROVIDER_OPTIONS = [
  { value: 'brevo', label: 'Brevo' },
  { value: 'mailchimp', label: 'Mailchimp' },
  { value: 'sendgrid', label: 'Twilio SendGrid' },
];

const JOB_STATUS_LABELS = {
  pending: 'Pending',
  running: 'Running',
  completed: 'Completed',
  failed: 'Failed',
};

function normalizeText(value) {
  return String(value || '').trim();
}

function providerLabel(provider) {
  const normalized = normalizeText(provider);
  return MARKETING_EMAIL_PROVIDER_OPTIONS.find((option) => option.value === normalized)?.label || normalized;
}

export function buildMarketingEmailProviderConnectionRows(connections = []) {
  return (Array.isArray(connections) ? connections : []).map((connection, index) => {
    const uid = normalizeText(connection?.uid);

    return {
      ...connection,
      id: uid || `provider-${index + 1}`,
      key: uid || `provider-${index + 1}`,
      providerLabel: providerLabel(connection?.provider),
      statusLabel: connection?.enabled ? 'Enabled' : 'Disabled',
      configuredLabel: connection?.configured ? 'Configured' : 'Needs API key',
    };
  });
}

export function buildMarketingEmailSyncJobRows(jobs = []) {
  return (Array.isArray(jobs) ? jobs : []).map((job, index) => {
    const uid = normalizeText(job?.uid);
    const status = normalizeText(job?.status || 'pending') || 'pending';

    return {
      ...job,
      id: uid || `sync-job-${index + 1}`,
      key: uid || `sync-job-${index + 1}`,
      providerLabel: providerLabel(job?.provider),
      statusLabel: JOB_STATUS_LABELS[status] || status,
      resultLabel: `${Number(job?.syncedCount || 0)} synced / ${Number(job?.selectedCount || 0)} selected`,
    };
  });
}
